export const getFileName = (url) => {
  if (!url) return '';
  const fileName = url.split('/').pop();
  const fileNameOnly = fileName.split('.').shift();
  const currentFileName =
    fileName !== '' ? `${fileNameOnly}.PDF`.toUpperCase() : url;
  return decodeURIComponent(currentFileName);
};
